var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTagsChannels(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.91667 5.66667H12.3333M12.3333 5.66667V16.0833M12.3333 5.66667L16.0833 1.91667M16.5 11.781V2.16667C16.5 1.93331 16.5 1.81663 16.4546 1.7275C16.4146 1.6491 16.3509 1.58536 16.2725 1.54541C16.1834 1.5 16.0667 1.5 15.8333 1.5H6.21895C6.01513 1.5 5.91321 1.5 5.81731 1.52303C5.73228 1.54344 5.65099 1.57711 5.57643 1.6228C5.49233 1.67433 5.42027 1.7464 5.27614 1.89052L1.89052 5.27614C1.7464 5.42027 1.67433 5.49233 1.6228 5.57643C1.57711 5.65099 1.54344 5.73228 1.52303 5.81731C1.5 5.91321 1.5 6.01513 1.5 6.21895V15.8333C1.5 16.0667 1.5 16.1834 1.54541 16.2725C1.58536 16.3509 1.6491 16.4146 1.7275 16.4546C1.81663 16.5 1.93331 16.5 2.16667 16.5H11.781C11.9849 16.5 12.0868 16.5 12.1827 16.477C12.2677 16.4566 12.349 16.4229 12.4236 16.3772C12.5077 16.3257 12.5797 16.2536 12.7239 16.1095L16.1095 12.7239C16.2536 12.5797 16.3257 12.5077 16.3772 12.4236C16.4229 12.349 16.4566 12.2677 16.477 12.1827C16.5 12.0868 16.5 11.9849 16.5 11.781Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagsChannels);
export default __webpack_public_path__ + "static/media/tags-channels.e57b2d0da9bf8542e61cfef1cc387e10.svg";
export { ForwardRef as ReactComponent };